var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.70569L21 7.20569L21 8.79425L19.5 8.79419L19.4999 19.7943C19.4999 20.6227 18.8284 21.2943 17.9999 21.2943H5.99991C5.17148 21.2943 4.49991 20.6227 4.49991 19.7943L4.49994 8.79425H3V7.20569L12 2.70569ZM18 8.79419L5.99994 8.79425L5.99991 19.7943H9.99991V14.7057C9.99991 13.6011 10.8953 12.7057 11.9999 12.7057C13.1045 12.7057 13.9999 13.6011 13.9999 14.7057V19.7943H17.9999L18 8.79419ZM17.8229 7.29425L12 4.38275L6.17703 7.29425H17.8229Z",
    fill: "#777D87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssets);
export default __webpack_public_path__ + "static/media/assets.1c19cabf98ff53d40dc239e852d884a0.svg";
export { ForwardRef as ReactComponent };